import React, { Fragment, ReactNode } from 'react';
import {
  FormControlLabel,
  Radio,
  RadioGroup as MuiRadioGroup,
  styled,
  RadioGroupProps as MuiRadioGroupProps,
  RadioProps,
} from '@mui/material';

export interface RadioOption {
  value?: string;
  label?: ReactNode;
  isDisabled?: boolean;
  children?: ReactNode;
}
interface RadioGroupProps extends MuiRadioGroupProps {
  selectedOption?: RadioOption;
  options: RadioOption[];
  onOptionSelected: (option: RadioOption) => void;
  slotProps?: {
    radioControl?: RadioProps;
  };
}

const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  color: theme.palette.grey[800],
}));

export const RadioGroup = ({
  selectedOption,
  options,
  onOptionSelected,
  slotProps,
  ...restProps
}: RadioGroupProps) => {
  const handleOptionSelected = (_: React.ChangeEvent<HTMLInputElement>, value: string) => {
    const newOption = options.find((option) => option.value === value);

    if (newOption) {
      onOptionSelected(newOption);
    }
  };

  return (
    <MuiRadioGroup
      className="radio-group"
      value={selectedOption?.value ?? ''}
      onChange={handleOptionSelected}
      {...restProps}
    >
      {options.map(({ value, label, isDisabled, children }) => (
        <Fragment key={value}>
          <StyledFormControlLabel
            id={`radio-option-${value}`}
            value={value}
            control={<Radio {...slotProps?.radioControl} />}
            label={label}
            disabled={isDisabled ?? false}
          />
          {children}
        </Fragment>
      ))}
    </MuiRadioGroup>
  );
};
